export default "__VITE_ASSET__398432c2__"